/**
 *
 * Asynchronously loads the component for RadioGroupAdapter
 *
 */

import { lazyLoad } from 'utils/loadable';

export const RadioGroupAdapter = lazyLoad(
  () => import('./index'),
  module => module.RadioGroupAdapter,
);
